import React from "react";
import check from "./check.png";

const style = {
	message: {
		textAlign: "center",
		fontSize: "25px",
		padding: "9%",
		color: "#0057a0",
		borderStyle: "solid",
		borderWidth: "1px"
	},
	image: {
		height: 50,
	},
	span: {
		fontSize: "13px",
		color: "#808080"

	}
};

const SuccessMessage = (props) => (<div>
	<div style={style.message}>
        Nous avons examiné un erreur lors la confirmation de N° de téléphone.
<br />
		<img src={check} style={style.image} alt="success" /><br />
		<span style={style.span}>Veuillez réessayer</span>
	</div>
</div>);

export default SuccessMessage;



// WEBPACK FOOTER //
// ./src/Containers/Success.js